export default function handleCpfMask(ev: Event) {
  const { key } = ev as KeyboardEvent;
  if (key === 'Delete' || key === 'Backspace') return;

  const target = ev.target as HTMLInputElement;
  if (target) {
    const length = target.value.length;
    if (length === 3 || length === 7)
      (ev.target as HTMLInputElement).value += '.';
    if (length === 11) (ev.target as HTMLInputElement).value += '-';
  }
}
